import { gql } from '@apollo/client';
import { useMutation } from '@apollo/client/react';

const UPDATE_CONDITION_VERSION_MUTATION = gql`
    mutation updateConditionVersion($type: ConditionType!, $versionNumber: Int!, $contentFr: String!, $contentEn: String!) {
        updateConditionVersion(type: $type, versionNumber: $versionNumber, contentFr: $contentFr, contentEn: $contentEn) {
            uuid
            versionNumber
            contentFr
            contentEn
            createdAt
            publishedAt
        }
    }
`;

const useUpdateConditionVersion = () => {
    const [mutate, { loading, error }] = useMutation(UPDATE_CONDITION_VERSION_MUTATION);

    const updateConditionVersion = async (type, versionNumber, contentFr, contentEn) => {
        return mutate({
            variables: {
                type,
                versionNumber,
                contentFr,
                contentEn,
            },
        });
    };

    return { updateConditionVersion, loading, error };
};

export default useUpdateConditionVersion;
